import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'next-i18next';

import { Container, PercentageBar, ValueButton } from './styles';
import { useSlider } from '@spa/shared/hooks/slider';
export * from './range';

export const Slider = ({ min, max, value, name, step = 1, onChange = () => {}, onClick = () => {} }) => {
  const ref = useRef();
  const { t } = useTranslation();
  const { onDrag, percentage, dragPosition } = useSlider(ref, name, min, max, value, onChange, step);

  return (
    <Container ref={ref} onClick={e => onClick(e)}>
      <PercentageBar style={{ width: `${percentage}%` }} />
      <ValueButton
        aria-label={t('aria.slider.label', { name })}
        tabIndex="0"
        role="slider"
        aria-valuemax={max}
        aria-valuemin={min}
        aria-valuenow={value}
        {...onDrag()}
        dragPosition={dragPosition}
      />
    </Container>
  );
};

Slider.propTypes = {
  name: PropTypes.string.isRequired,
  min: PropTypes.number.isRequired,
  max: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
  step: PropTypes.number,
  onChange: PropTypes.func,
  onClick: PropTypes.func
};
